import React, { useEffect, useRef } from 'react';
import useStore from '../../../../store';
import PuzzlePiece from './PuzzlePiece';
import { getUserColor } from '../../utils/theme/userColor';
import './ReservedPieces.css';
import { getFunnyNickname } from '../../../../utils/formatter';

const ReservedPieces = () => {
  // Подписываемся на изменения для ререндера
  useStore(state => state.puzzleRender);
  useStore(state => state.info?.game?.users);
  const store = useStore.getState();
  const { ref } = store;
  const { puzzle, info } = ref;
  const { state, config, boardTransform, methods: puzzleMethods, layout, boardCanvas } = puzzle;
  const { pieces } = state;
  const users = info.game?.users || {};
  const funnyNicknames = window.t('funny_nicknames', { returnObjects: true });

  // Проверки на наличие необходимых данных
  if (!pieces || !config || !layout?.trayPiecesLayout || !layout?.boardContainer || !layout?.trayContainer || !boardCanvas?.rect || !puzzleMethods?.calculateOnePiece) {
    return null;
  }

  const now = Date.now();

  // Находим все зарезервированные кусочки (логика фильтрации остается)
  const reservedPieceIds = Object.keys(pieces)
    .filter(id => {
      const piece = pieces[id];
      if (piece.placed) return false;
      const showTrace = piece?.unreserved > now - 1500; // След 
      const reserved = piece?.reservedUntil > now;
      return reserved || showTrace;
    });

  if (reservedPieceIds.length === 0) {
    return null;
  }

  const { pieceLayoutData } = layout.trayPiecesLayout;
  const trayContainerRect = layout.trayContainer;
  const boardRect = boardCanvas.rect; // Фактическое положение канваса доски

  return (
    <>
      {reservedPieceIds.map(pieceId => {
        const piece = pieces[pieceId];
        if (!piece || !piece.baseDimensions) return null;

        // Рассчитываем размеры и выступы для текущего масштаба
        const { scaledTotalDimensions, scaledTabExtensions, trayPosition } = puzzleMethods.calculateOnePiece(pieceId);

        let finalPosX_page, finalPosY_page;

        if (piece.onBoard) {

          if (!piece.currentPos) return null; // Нужны координаты на доске

          const basePosX_on_canvas = piece.currentPos.x;
          const basePosY_on_canvas = piece.currentPos.y;

          // 2. Позиция КОНТЕЙНЕРА (с выступами) относительно окна браузера
          finalPosX_page = boardRect.left + basePosX_on_canvas * boardTransform.scale - scaledTabExtensions.width;
          
          finalPosY_page = boardRect.top + basePosY_on_canvas * boardTransform.scale - scaledTabExtensions.height;

        } else { // Кусочек в трее

          finalPosX_page = trayPosition.x - scaledTabExtensions.width;
          finalPosY_page = trayPosition.y - scaledTabExtensions.height;

        }

        const isReserved = piece?.reservedUntil > now - 1500;

        const isTrace = !isReserved && piece?.unreserved > now - 5000;

        // Плавное исчезновение для следа
        let containerTransition = 'filter 0.5s linear, scale 0.5s linear, opacity 0.3s ease-in-out';
        if (isTrace) {
          containerTransition = 'filter 1s linear, scale 1s linear, opacity 1s linear'; // Линейное угасание контейнера
        }

        // Имя пользователя и цвет (по аналогии с HighlightedPieces)
        let reservedByName = '';
        const reservedByUser = piece.reservedBy ? users[piece.reservedBy] : null;
        if (piece.reservedBy) {
          if (reservedByUser) {
            reservedByName = reservedByUser.first_name || getFunnyNickname(piece.reservedBy, funnyNicknames);
            if (reservedByName.length > 10) {
              reservedByName = reservedByName.substring(0, 10) + '...';
            }
          } else {
             // Если пользователя нет в users (например, вышел), можно показать ID
             reservedByName = getFunnyNickname(piece.reservedBy, funnyNicknames);
          }
        }

        // Стили для контейнера
        const containerStyle = {
          position: 'fixed', // Используем fixed для позиционирования относительно viewport
          left: `${finalPosX_page}px`,
          top: `${finalPosY_page}px`,
          width: `${scaledTotalDimensions.width}px`,
          height: `${scaledTotalDimensions.height}px`,
          pointerEvents: 'none',
          zIndex: 495, // Между TrayPieces (480) и HighlightedPieces (500)
          transition: containerTransition, // Используем переменную
          willChange: 'opacity, filter, scale', // Добавляем filter и scale
        };

        // Стили для имени (по аналогии с HighlightedPieces, но без анимации пока)
        const nameStyle = {
          position: 'absolute',
          top: '-10px', // Выше кусочка
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#ffffff', // Оставляем белый цвет
          textShadow: '0 0 2px #000000', // Простая черная тень
          fontSize: '10px',
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          zIndex: 496, // Над контейнером
          transition: 'opacity 1s linear', // Используем переменную
          opacity: 0.5, // Добавляем управление opacity напрямую
        };

        return (
          <div
            key={pieceId}
            className= {isTrace ? 'unreserved-piece-container' : 'reserved-piece-container'} // Можно оставить для общих стилей, если есть
            style={containerStyle}
          >
            {/* PuzzlePiece сам учтет boardTransform.scale для своего внутреннего рендера */}
            <PuzzlePiece pieceId={pieceId} />
            {/* Добавляем имя пользователя */}
            {reservedByName && (
              <div className="reserved-piece-name" style={nameStyle}>
                {reservedByName}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default ReservedPieces;